document.addEventListener("DOMContentLoaded", function () {
    function closeNativeQuickView(){
      // Get all modals and ensure we clean up each one
      document.querySelectorAll('[data-quick-view-modal]').forEach(function(quickView) {
        // Remove size-guide-active class first
        quickView.classList.remove('size-guide-active');

        // Also check for any parent elements that might have the class
        let parentWithClass = quickView.closest('.size-guide-active');
        if (parentWithClass) {
          parentWithClass.classList.remove('size-guide-active');
        }

        // Prefer native close button if present to let theme run its own teardown
        var closeBtn = quickView.querySelector('[data-modal-close]');
        if(closeBtn && !quickView.classList.contains('size-guide-active')){
          closeBtn.click();
          return;
        }

        // Fallback: remove classes and body attribute
        quickView.classList.remove('is-visible', 'active');

        // Force remove any inline styles that might be keeping the modal visible
        quickView.style.removeProperty('display');
        quickView.style.removeProperty('opacity');
        quickView.style.removeProperty('visibility');

        // Clean up any related elements
        const backdrops = document.querySelectorAll('.modal-backdrop, .size-guide-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());

        setTimeout(function(){
          quickView.classList.remove('is-fixed');
          // Double check the class was removed
          quickView.classList.remove('size-guide-active');
        }, 100);

        document.body.setAttribute('data-fluorescent-overlay-open','false');
        document.body.classList.remove('quick-add-variant-open', 'size-guide-active');
      });

      // Additional cleanup for any lingering modals
      document.querySelectorAll('.size-guide-active').forEach(el => {
        el.classList.remove('size-guide-active');
      });
    }
    // Event delegation for tab buttons (works with dynamic popups too)
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-tab-button]");
      if (!btn) return; // Ignore clicks that aren't tab buttons

      var root = btn.closest("[data-size-guide-tabs]");
      if (!root) return;

      var target = btn.getAttribute("data-target");
      var panels = root.querySelectorAll("[data-tab-panel]");
      var buttons = root.querySelectorAll("[data-tab-button]");

      panels.forEach(function (p) {
        if ("#" + p.id === target) {
          p.classList.remove("hidden");
        } else {
          p.classList.add("hidden");
        }
      });

       // Toggle active class on buttons
       buttons.forEach(function (b) {
        b.classList.remove("active");
       });
      btn.classList.add("active");
  });

  // Variant quick add chips: add to cart on click
  document.addEventListener("click", function(e){
    var chip = e.target.closest("[data-variant-chips] .product-chips-options__item");
    if(!chip) return;
    if(chip.getAttribute("aria-disabled") === "true" || chip.hasAttribute("data-sold-out")) return;
    var variantId = chip.getAttribute("data-variant-id");
    if(!variantId) return;

    fetch("/cart/add.js",{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function(r){ return r.ok ? r.json() : r.json().then(function(err){ throw err; }); })
    .then(function(){
      // Ask theme to refresh quick cart via documented hook in theme.js
      document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
      // Then open, emulating PDP timing
      setTimeout(function(){
        // Ensure quick view is closed before opening cart drawer
        closeNativeQuickView();
        var cartIcon = document.querySelector('[data-js-cart-icon]');
        if(cartIcon){
          cartIcon.dispatchEvent(new Event('click', { bubbles: true }));
        } else {
          document.dispatchEvent(new CustomEvent("quick-cart:open"));
        }
      }, 300);
    })
    .catch(function(){});
  });

  // Variant quick add: render content inside native quick view modal
  document.addEventListener("click", function(e){
    var opener = e.target.closest('[data-variant-quick-add-open]');
    if(opener){
      e.preventDefault();
      var id = opener.getAttribute('data-modal-id');
      if(!id) return;
      var sourceModal = document.getElementById(id);
      if(!sourceModal) return;
      var sourceContent = sourceModal.querySelector('.variant-quick-add-modal__content');
      if(!sourceContent) return;

      var quickView = document.querySelector('[data-quick-view-modal]');
      if(!quickView) return;
      var modalContent = quickView.querySelector('.quick-view-modal__content');
      if(!modalContent) return;

      // Inject content
      modalContent.classList.remove('empty');
      modalContent.innerHTML = '';
      // Clone to avoid moving original nodes
      modalContent.appendChild(sourceContent.cloneNode(true));

      // Open native quick view (emulate theme open sequence)
      quickView.classList.add('is-fixed');
      setTimeout(function(){
        quickView.classList.add('active');
        setTimeout(function(){
          quickView.classList.add('is-visible');
        }, 50);
      }, 50);
      document.body.setAttribute('data-fluorescent-overlay-open','true');
      document.body.classList.add('quick-add-variant-open');
      return;
    }
  });

  // Close quick view when cart drawer is opened elsewhere in the theme
  document.addEventListener('quick-cart:open', function(){
    closeNativeQuickView();
  });

  // Also close on cart icon click (theme toggles drawer from this)
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-js-cart-icon]')){
      closeNativeQuickView();
    }
  });

    // Show the first tab by default when a size guide is inserted
    function initSizeGuide(root) {
      var buttons = root.querySelectorAll("[data-tab-button]");
      var panels = root.querySelectorAll("[data-tab-panel]");
      if (buttons.length && panels.length) {
        var target = buttons[0].getAttribute("data-target");
        panels.forEach(function (p) {
          if ("#" + p.id === target) {
            p.classList.remove("hidden");
          } else {
            p.classList.add("hidden");
          }
        });

        buttons.forEach(function (b, i) {
            b.classList.toggle("active", i === 0);
        });
      }
    }

    // MegaNav hover logic: show the UL next to hovered H4, default to first on load
    function initMeganavHover(root) {
      var navs = root.querySelectorAll('.meganav__nav');
      if (!navs.length) return;

      navs.forEach(function(nav){
        if (nav.__meganavHoverInit) return; // avoid double init
        nav.__meganavHoverInit = true;

        var parents = nav.querySelectorAll('ul[depth="0"] > li.has-children');
        if (!parents.length) return;

        var defaultIndex = 0;
        function setActive(index) {
          parents.forEach(function(li, i){
            li.classList.toggle('active', i === index);
          });
        }

        // Default state on load
        setActive(defaultIndex);

        // Hover over heading to switch
        nav.addEventListener('mouseover', function(e){
          var h4 = e.target.closest('ul[depth="0"] > li.has-children > h4');
          if (!h4 || !nav.contains(h4)) return;
          var li = h4.parentElement;
          var idx = Array.prototype.indexOf.call(parents, li);
          if (idx > -1) setActive(idx);
        });

        // Keyboard focus support
        nav.addEventListener('focusin', function(e){
          var link = e.target.closest('ul[depth="0"] > li.has-children > h4 a');
          if (!link || !nav.contains(link)) return;
          var li = link.closest('li.has-children');
          var idx = Array.prototype.indexOf.call(parents, li);
          if (idx > -1) setActive(idx);
        });

        // When leaving the nav area, restore first
        nav.addEventListener('mouseleave', function(){
          setActive(defaultIndex);
        });
      });
    }

    // Initialize any existing size guides
    document.querySelectorAll("[data-size-guide-tabs]").forEach(initSizeGuide);

    // Initialize any existing MegaNavs
    initMeganavHover(document);

    // Observe dynamically added popups and menus and init them too
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches("[data-size-guide-tabs]")) {
            initSizeGuide(node);
          }
          if (node.matches && node.matches('.meganav__nav')) {
            initMeganavHover(node);
          } else if (node.querySelector) {
            // If subtree contains meganav navs
            var innerNav = node.querySelector('.meganav__nav');
            if (innerNav) initMeganavHover(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // View toggle (Product View | Model View)
    function applyViewMode(mode) {
      var body = document.body;
      body.classList.remove('view--product', 'view--model');
      if (mode === 'model') {
        body.classList.add('view--model');
      } else {
        body.classList.add('view--product');
      }
      var buttons = document.querySelectorAll('[data-view-toggle] .filter-bar__button--view');
      buttons.forEach(function(btn){
        var isActive = btn.getAttribute('data-view-mode') === mode;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    var saved = localStorage.getItem('collectionViewMode') || 'product';
    applyViewMode("product");

    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-view-toggle] .filter-bar__button--view');
      if (!btn) return;
      var mode = btn.getAttribute('data-view-mode');
      applyViewMode(mode);
    });
  });


// Dynamic height for product card meta: START

function setProductMetaHeight() {
  const productItems = document.querySelectorAll('.product-item');

  productItems.forEach(item => {
    const meta = item.querySelector('.product-item__meta');
    if (meta) {
      const metaHeight = meta.offsetHeight;
      item.style.setProperty('--product-item-meta-height', `${metaHeight}px`);
    }
  });
}

// Measure as soon as markup is parsed. `load` waits for every image, which
// left Stoq's injected buttons unpositioned for a visible moment.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setProductMetaHeight);
} else {
  setProductMetaHeight();
}

window.addEventListener('load', setProductMetaHeight);

window.addEventListener('resize', setProductMetaHeight);

// Global observer for *any* product-item additions (filter, load more, ajax)
const bodyObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        if (node.classList.contains('product-item')) {
          setProductMetaHeight([node]);
        } else {
          const newItems = node.querySelectorAll?.('.product-item');
          if (newItems && newItems.length) {
            setProductMetaHeight(newItems);
          }
        }
      }
    });
  });
});

bodyObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Dynamic height for product card meta: END

// Trigger Register Interest button: START

document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".trigger-register-interest");
  if (!trigger) return;
  e.preventDefault();

  const modalContent = trigger.closest(".variant-quick-add-modal__content");
  if (!modalContent) return;

  const productId = modalContent.getAttribute("data-product-id");
  if (!productId) return;

  function findButton() {
    const el = document.querySelector('.product-item [data-product-id="' + productId + '"]');
    const item = el && el.closest(".product-item");
    return item && item.querySelector(".restock-rocket-button-collection");
  }

  const button = findButton();
  if (button) {
    button.click();
    return;
  }

  // Stoq has not injected yet (slow connection). Honour the click once it has.
  trigger.setAttribute("aria-busy", "true");
  const started = Date.now();
  const poll = setInterval(function () {
    const b = findButton();
    if (b) {
      clearInterval(poll);
      trigger.removeAttribute("aria-busy");
      b.click();
    } else if (Date.now() - started > 5000) {
      clearInterval(poll);
      trigger.removeAttribute("aria-busy");
    }
  }, 150);
});

/* Stoq (Restock Rocket) only ships product and collection bundles and gates the
   widget on _StoqConfig.pageType, so it never loads on `page` (lookbooks) or
   `article` (press) templates. Both render the same product-item markup as
   collection cards, so we masquerade as a collection and load that bundle.
   pageType must stay overridden: renderButtonsForPage re-reads it at call time.
   Side effect: Stoq's pixel reports these views as page_type "collection".
   Button styling lives in custom.css under
   .product-item__meta .restock-rocket-button-collection */
(function () {
  var loaded = false;

  function tryLoad() {
    var cfg = window._StoqConfig;
    if (!cfg) return false;
    if (cfg.pageType !== "page" && cfg.pageType !== "article") return true;
    if (typeof window.createRestockRocketScript !== "function") return false;
    if (!cfg.scriptUrlCollection) return false;
    loaded = true;
    cfg.pageType = "collection";
    window.createRestockRocketScript(cfg.scriptUrlCollection);
    return true;
  }

  if (!tryLoad()) {
    var poll = setInterval(function () { if (tryLoad()) clearInterval(poll); }, 100);
    setTimeout(function () { clearInterval(poll); }, 15000);
  }

  // Lookbook drawer clones cards after load, so re-scan when they appear.
  var pending;
  var mo = new MutationObserver(function () {
    if (!loaded) return;
    if (!document.querySelector(".lookbook-drawer .product-item__text")) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      var rr = window._RestockRocket;
      if (rr && typeof rr.renderButtonsForPage === "function") rr.renderButtonsForPage();
    }, 100);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

// Password Quick View functionality
(function() {
  document.addEventListener('click', function(e) {
    const button = e.target.closest('[data-custom-quick-view="true"]');
    if (!button) return;

    // Check if this button is from password collection section and has password mode
    if (button.hasAttribute('data-password-collection-section') &&
        button.getAttribute('data-password-collection-section') === 'true' &&
        button.hasAttribute('data-password-mode') &&
        button.getAttribute('data-password-mode') === 'true') {
      e.preventDefault(); // Prevent any default behavior
      e.stopImmediatePropagation(); // Stop any other event listeners

      const productUrl = button.getAttribute('data-product-url');
      if (!productUrl || !window.passwordQuickViewContent) return;

      // Find the correct product content by matching the URL
      let productContent = null;
      for (const [, productData] of Object.entries(window.passwordQuickViewContent)) {
        if (productData && productData.url === productUrl) {
          productContent = productData.content;
          break;
        }
      }

      if (productContent) {
        // Use the matched product content
        renderPasswordQuickViewModal(productContent);
      }
    }
  }, true);

  // Close password quick view modal when close button is clicked
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-modal-close]')) {
      const modal = document.querySelector('[data-quick-view-modal]');
      if (modal && modal.classList.contains('is-visible')) {
        modal.classList.remove('is-visible', 'active');
        document.body.setAttribute('data-fluorescent-overlay-open', 'false');
      }
    }
  });
})();

function renderPasswordQuickViewModal(modalContent) {
  // Find and update the modal
  const modal = document.querySelector('[data-quick-view-modal]');
  if (modal) {
    const modalContentEl = modal.querySelector('.modal__inner');
    if (modalContentEl) {
      modalContentEl.innerHTML = `
        <div class="quick-view-modal__content" data-quick-view-modal-content>
          ${modalContent}
        </div>
        <button
          type="button"
          data-modal-close
          class="modal__close-icon"
          aria-label="Close modal"
        >
          <svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1 1L15 15M1 15L15 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      modal.classList.add('is-visible', 'active');
      modal.classList.remove('empty');

      // Ensure body attribute is set for modal overlay
      document.body.setAttribute('data-fluorescent-overlay-open', 'true');

      // Initialize popup functionality for the modal content
      initializeModalPopups();

      // Store current content for back button functionality
      window.lastPasswordQuickViewContent = modalContent;
    }
  }
}

// Initialize popup functionality for modal content
function initializeModalPopups() {
  const popupTriggers = document.querySelectorAll('[data-popup-trigger]');
  popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const modalContentId = this.getAttribute('data-modal-content-id');
      if (modalContentId) {
        const modalContent = document.getElementById(modalContentId);
        if (modalContent) {
          // Check if we're in a password collection context
          const isPasswordCollection = document.querySelector('[data-password-collection-section="true"]');

          if (isPasswordCollection) {
            // For password collection, replace modal content with size guide only
            replaceModalWithPopupContent(modalContent);
          } else {
            // For regular product pages, show popup as overlay
            showPopupOverlay(modalContent);
          }
        }
      }
    });
  });
}

// Replace modal content with popup content (for password collection)
function replaceModalWithPopupContent(popupContent) {
  const modal = document.querySelector('[data-quick-view-modal]');
  if (modal) {
    const modalInner = modal.querySelector('.modal__inner');
    if (modalInner) {
      // Clone the popup content to avoid modifying the original
      const clonedContent = popupContent.cloneNode(true);
      clonedContent.style.display = 'block';

      // Add size guide active class to modal wrapper
      modal.classList.add('size-guide-active');

      // Clear modal content and append size guide
      modalInner.innerHTML = `
        <div class="quick-view-modal__content" data-quick-view-modal-content>
          <div class="modal__content">
            ${clonedContent.outerHTML}
          </div>
        </div>
        <button
          type="button"
          data-modal-close
          class="modal__close-icon"
          aria-label="Close modal"
        >
          <svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M1 1L15 15M1 15L15 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
    }
  }
}

// Show popup as overlay (for regular product pages)
function showPopupOverlay(modalContent) {
  // Hide all other popup content first
  document.querySelectorAll('.information-popup__content').forEach(content => {
    content.style.display = 'none';
  });

  // Show the target popup content
  modalContent.style.display = 'block';

  // Add modal backdrop if it doesn't exist
  let backdrop = document.querySelector('.modal-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop';
    backdrop.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 999; display: block;';
    document.body.appendChild(backdrop);

    backdrop.addEventListener('click', function() {
      closeAllPopups();
    });
  }

  // Add close button if it doesn't exist
  if (!modalContent.querySelector('.popup-close-button')) {
    const closeButton = document.createElement('button');
    closeButton.className = 'popup-close-button btn btn--rounded';
    closeButton.innerHTML = '×';
    closeButton.style.cssText = 'position: absolute; top: 10px; right: 10px; background: #fff; border: 1px solid #ccc; width: 30px; height: 30px; border-radius: 50%; font-size: 18px; cursor: pointer; z-index: 1001;';
    closeButton.addEventListener('click', function() {
      closeAllPopups();
    });
    modalContent.style.position = 'relative';
    modalContent.appendChild(closeButton);
  }
}

// Close all popups
function closeAllPopups() {
  // Handle all quick view modals
  document.querySelectorAll('[data-quick-view-modal]').forEach(modal => {
    // Ensure all modal states are reset
    modal.classList.remove('size-guide-active', 'is-visible', 'active');

    // Remove any inline styles that might be keeping the modal visible
    modal.style.removeProperty('display');
    modal.style.removeProperty('opacity');
    modal.style.removeProperty('visibility');

    // For password collection, handle content restoration
    const isPasswordCollection = document.querySelector('[data-password-collection-section="true"]');
    if (isPasswordCollection && window.lastPasswordQuickViewContent) {
      const modalInner = modal.querySelector('.modal__inner');
      if (modalInner) {
        modalInner.innerHTML = `
          <div class="quick-view-modal__content" data-quick-view-modal-content>
            ${window.lastPasswordQuickViewContent}
          </div>
          <button
            type="button"
            data-modal-close
            class="modal__close-icon"
            aria-label="Close modal"
          >
            <svg class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1 1L15 15M1 15L15 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        `;
        // Reinitialize popup functionality for the restored content
        initializeModalPopups();
      }
    }
  });

  // First, clean up any size-guide-active classes on the document
  setTimeout(() => {
    document.querySelectorAll('.size-guide-active').forEach(el => {
      el.classList.remove('size-guide-active');
    });
  }, 1000);

  // For regular product pages, hide overlay popups
  document.querySelectorAll('.information-popup__content').forEach(content => {
    content.style.display = 'none';
  });

  // Remove any remaining backdrops
  document.querySelectorAll('.modal-backdrop, .size-guide-backdrop').forEach(backdrop => {
    backdrop.remove();
  });

  // Reset body classes and attributes
  document.body.setAttribute('data-fluorescent-overlay-open', 'false');
  document.body.classList.remove('quick-add-variant-open', 'size-guide-active');
}

// Handle modal close and wash click events
document.addEventListener('click', function(e) {
  // Check if clicked element or its parent is a close button or modal wash
  const closeButton = e.target.closest('[data-modal-close], .modal__wash');

  if (closeButton) {
    // Find the closest modal
    const modal = closeButton.closest('[data-quick-view-modal]');
    if (modal) {
      // Remove size-guide-active class
      modal.classList.remove('size-guide-active');

      // Also check for any parent elements that might have the class
      const parentWithClass = modal.closest('.size-guide-active');
      if (parentWithClass) {
        parentWithClass.classList.remove('size-guide-active');
      }
    }
  }
});

// Password quick view: infinite slide between product images
function qvSetPos(track, index, animate) {
  track.style.transition = animate ? '' : 'none';
  track.style.transform = 'translateX(' + (-index * 100) + '%)';
  if (!animate) {
    void track.offsetWidth; // flush before re-enabling transitions
    track.style.transition = '';
  }
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-qv-media-prev], [data-qv-media-next]');
  if (!btn) return;
  e.preventDefault();

  var container = btn.closest('.product__media-container');
  if (!container) return;
  var track = container.querySelector('.product__media');
  if (!track) return;
  if (track.dataset.qvBusy === 'true') return;

  var real = Array.prototype.slice.call(
    track.querySelectorAll('.product__media-item:not([data-qv-clone])')
  );
  if (real.length < 2) return;

  // First interaction: build a looping track by cloning the end images.
  if (!track.dataset.qvReady) {
    var start = real.findIndex(function (el) { return !el.classList.contains('hidden'); });
    if (start === -1) start = 0;
    real.forEach(function (el) { el.classList.remove('hidden'); });

    var head = real[real.length - 1].cloneNode(true);
    var tail = real[0].cloneNode(true);
    head.setAttribute('data-qv-clone', '');
    tail.setAttribute('data-qv-clone', '');
    track.insertBefore(head, real[0]);
    track.appendChild(tail);

    track.dataset.qvReady = 'true';
    track.dataset.qvCount = String(real.length);
    track.dataset.qvIndex = String(start + 1);
    qvSetPos(track, start + 1, false);

    track.addEventListener('transitionend', function (ev) {
      if (ev.propertyName !== 'transform') return;
      var count = Number(track.dataset.qvCount);
      var i = Number(track.dataset.qvIndex);
      if (i === 0) {
        i = count;
        track.dataset.qvIndex = String(i);
        qvSetPos(track, i, false);
      } else if (i === count + 1) {
        i = 1;
        track.dataset.qvIndex = String(i);
        qvSetPos(track, i, false);
      }
      track.dataset.qvBusy = 'false';
    });
  }

  var index = Number(track.dataset.qvIndex);
  index += btn.hasAttribute('data-qv-media-next') ? 1 : -1;
  track.dataset.qvIndex = String(index);
  track.dataset.qvBusy = 'true';
  qvSetPos(track, index, true);
});